import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import theme from '..//easyclaim.app.theme/theme';
import {
	CenteredCircle,
	GrowingDetailContainer,
	StyledCallIcon,
} from '../easyclaim.app.components/index';

import { ScreenComponent } from './ScreenComponent';

export class Callback extends ScreenComponent<{}, {}> {
	public render() {
		return (
			<div className="main-container">
				<h2 className="callback-title">
					<FormattedMessage id="callback.headline" />
				</h2>
				<GrowingDetailContainer>
					<CenteredCircle
						size="6rem"
						borderColor={theme.colors.success}
						borderStyle="solid"
						borderWidth="3px"
					>
						<StyledCallIcon />
					</CenteredCircle>
					<Paragraph>
						<FormattedMessage id="callback.description" />
					</Paragraph>
				</GrowingDetailContainer>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
